(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-add-bundle-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-product-tabs-popup')) {
    class YGProductTabsPopup extends HTMLElement {
      connectedCallback() {
        this.initModalSwiper();
        this.bindEvents();
      }

      disconnectedCallback() {
        if (this.modalResizeHandler) {
          window.removeEventListener('resize', this.modalResizeHandler);
        }
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const addVariantBtn = event.target.closest('[data-add-variant]');

          if (addVariantBtn && this.contains(addVariantBtn)) {
            event.preventDefault();

            const variantId = addVariantBtn.dataset.variantId || '';

            if (variantId) {
              this.addItemsToCart(
                [
                  {
                    id: Number(variantId),
                    quantity: 1,
                  },
                ],
                addVariantBtn
              );
            }

            return;
          }

          const addAllBtn = event.target.closest('[data-add-all-popup-products]');

          if (addAllBtn && this.contains(addAllBtn)) {
            event.preventDefault();
            this.handleAddAllProducts(addAllBtn);
            return;
          }

          const prevBtn = event.target.closest('[data-modal-prev]');

          if (prevBtn && this.contains(prevBtn)) {
            event.preventDefault();
            this.goToPage(this.currentPage - 1);
            return;
          }

          const nextBtn = event.target.closest('[data-modal-next]');

          if (nextBtn && this.contains(nextBtn)) {
            event.preventDefault();
            this.goToPage(this.currentPage + 1);
          }
        });
      }

      initModalSwiper() {
        this.modalItems = Array.from(this.querySelectorAll('[data-modal-product-item]'));

        this.modalPageCountEl = this.querySelector('[data-modal-page-count]');
        this.modalPrevEl = this.querySelector('[data-modal-prev]');
        this.modalNextEl = this.querySelector('[data-modal-next]');
        this.modalPaginationEl = this.querySelector('.yg-modal-pagination');

        this.currentPage = 1;

        this.modalResizeHandler = this.updateModalPagination.bind(this);

        window.addEventListener('resize', this.modalResizeHandler);

        this.updateModalPagination();
      }

      getModalPerPage() {
        return window.innerWidth >= 1000 ? 3 : 2;
      }

      updateModalPagination() {
        if (!this.modalPageCountEl || !this.modalItems?.length) {
          if (this.modalPaginationEl) {
            this.modalPaginationEl.classList.add('is-hidden');
          }

          return;
        }

        const perPage = this.getModalPerPage();
        const totalPages = Math.max(1, Math.ceil(this.modalItems.length / perPage));

        this.currentPage = Math.min(Math.max(this.currentPage || 1, 1), totalPages);

        this.modalItems.forEach((item, index) => {
          const pageIndex = Math.floor(index / perPage) + 1;

          item.hidden = pageIndex !== this.currentPage;
        });

        if (this.modalPaginationEl) {
          this.modalPaginationEl.classList.toggle('is-hidden', totalPages <= 1);
        }

        this.modalPageCountEl.textContent = `${String(this.currentPage).padStart(2, '0')} / ${String(
          totalPages
        ).padStart(2, '0')}`;

        if (this.modalPrevEl) {
          this.modalPrevEl.disabled = this.currentPage <= 1;
        }

        if (this.modalNextEl) {
          this.modalNextEl.disabled = this.currentPage >= totalPages;
        }
      }

      goToPage(page) {
        this.currentPage = page;
        this.updateModalPagination();
      }

      handleAddAllProducts(triggerButton = null) {
        const itemsMap = new Map();

        const popupItems = Array.from(this.querySelectorAll('[data-popup-item]'));

        popupItems.forEach((item) => {
          if (item.dataset.available !== 'true') return;

          const variantId = item.dataset.variantId || '';

          if (!variantId) return;

          const key = String(variantId);

          itemsMap.set(key, (itemsMap.get(key) || 0) + 1);
        });

        const items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({
          id: Number(id),
          quantity,
        }));

        if (items.length) {
          this.addItemsToCart(items, triggerButton);
        }
      }

      async addItemsToCart(items = [], triggerButton = null) {
        if (!items.length) return;

        const wasDisabled = triggerButton ? triggerButton.disabled : false;

        if (triggerButton) {
          triggerButton.disabled = true;
          triggerButton.setAttribute('aria-busy', 'true');
        }

        const sectionsToBundle = ['variant-added'];

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: {
              sections: sectionsToBundle,
            },
          })
        );

        const bundledSections = Array.from(new Set(sectionsToBundle.filter(Boolean)));

        const currentVariantId = items[0].id;

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items,
            sections: bundledSections.join(','),
            sections_url: `${Shopify.routes.root}variants/${currentVariantId}`,
          }),
        });

        try {
          const responseJson = await response.json();

          if (!response.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            return;
          }

          if (
            window.themeVariables?.settings?.cartType === 'page' ||
            window.themeVariables?.settings?.pageType === 'cart'
          ) {
            window.location.href = `${Shopify.routes.root}cart`;
            return;
          }

          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

          cartContent.sections = responseJson.sections || {};

          document.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                cart: cartContent,
              },
            })
          );
        } finally {
          if (triggerButton) {
            triggerButton.removeAttribute('aria-busy');
            triggerButton.disabled = wasDisabled;
          }
        }
      }
    }

    customElements.define('yg-product-tabs-popup', YGProductTabsPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-card-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGCardTabsPanel extends HTMLElement {
    connectedCallback() {
      this._pageSize = parseInt(this.dataset.pageSize || '8', 10);
      this._currentPage = 1;

      this._cards = Array.from(this.querySelectorAll('.yg-card-tabs-card'));
      this._pagination = this.querySelector('.yg-card-tabs-pagination');

      // 如果没有分页器，无需处理
      if (!this._pagination) return;

      this._pageButtons = Array.from(this._pagination.querySelectorAll('.yg-card-tabs-page-number'));
      this._prevBtn = this._pagination.querySelector('[data-action="prev"]');
      this._nextBtn = this._pagination.querySelector('[data-action="next"]');
      this._totalPages = this._pageButtons.length;

      this._pagination.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        if (btn.matches('.yg-card-tabs-page-number')) {
          this._goTo(parseInt(btn.dataset.page, 10));
        } else if (btn.dataset.action === 'prev') {
          this._goTo(this._currentPage - 1);
        } else if (btn.dataset.action === 'next') {
          this._goTo(this._currentPage + 1);
        }
      });

      this._render();
    }

    _goTo(page) {
      if (page < 1 || page > this._totalPages) return;
      this._currentPage = page;
      this._render();
    }

    _render() {
      const start = (this._currentPage - 1) * this._pageSize;
      const end = start + this._pageSize;

      this._cards.forEach((card, i) => {
        card.classList.toggle('is-hidden', i < start || i >= end);
      });

      this._pageButtons.forEach((btn) => {
        btn.classList.toggle('is-active', parseInt(btn.dataset.page, 10) === this._currentPage);
      });

      if (this._prevBtn) this._prevBtn.disabled = this._currentPage <= 1;
      if (this._nextBtn) this._nextBtn.disabled = this._currentPage >= this._totalPages;
    }
  }

  if (!customElements.get('yg-card-tabs-panel')) {
    customElements.define('yg-card-tabs-panel', YGCardTabsPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-parts-scroll"] && !Shopify.designMode) return;
  try {
    
  class YGImagePartsScroll extends YGUtils {
    constructor() {
      super();
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    connectedCallback() {
      this.productCards = this.querySelectorAll('[data-product-card]');

      this.productCards.forEach((card) => {
        const toggle = card.querySelector('[data-variant-toggle]');
        const atcButton = card.querySelector('[data-atc-button]');
        const options = card.querySelectorAll('[data-variant-option]');

        if (toggle) {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleVariantDropdown(card);
          });
        }

        options.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectVariant(card, option);
          });
        });

        if (atcButton) {
          atcButton.addEventListener('click', async (event) => {
            event.preventDefault();
            await this.handleAddButton(event.currentTarget);
          });
        }
      });

      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.closeAllDropdowns();
    }

    toggleVariantDropdown(card) {
      const dropdown = card.querySelector('[data-variant-options]');
      if (!dropdown) return;

      const isOpen = dropdown.classList.contains('is-open');
      this.closeAllDropdowns();

      if (!isOpen) {
        card.classList.add('is-open');
        dropdown.classList.add('is-open');
      }
    }

    closeAllDropdowns() {
      this.querySelectorAll('[data-product-card]').forEach((card) => {
        card.classList.remove('is-open');
        const dropdown = card.querySelector('[data-variant-options]');
        if (dropdown) dropdown.classList.remove('is-open');
      });
    }

    async handleAddButton(addButton) {
      if (!addButton) return;

      const payload = this.buildBundlePayload(addButton);
      if (!payload.variantId) return;

      const bundleApi = window.YGBundleBuilderBarV1External;

      try {
        if (bundleApi && typeof bundleApi.addAccessory === 'function') {
          await bundleApi.addAccessory(payload);
          return;
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(payload.variantId),
            quantity: Number(payload.quantity || 1),
          }),
        });
      } catch (_) {}
    }

    buildBundlePayload(addButton) {
      return {
        productId: addButton.dataset.bundleProductId || '',
        variantId: addButton.dataset.variantId || '',
        gid: addButton.dataset.gid || `gid://shopify/ProductVariant/${addButton.dataset.variantId || ''}`,
        title: addButton.dataset.title || '',
        image: addButton.dataset.image || '',
        price: addButton.dataset.price || '',
        compareAtPrice: addButton.dataset.compareAtPrice || addButton.dataset.price || '',
        available: addButton.dataset.available === 'true',
        quantity: Number(addButton.dataset.quantity || 1),
      };
    }

    syncAddButtonByVariant(addButton, option, productTitle) {
      if (!addButton || !option) return;

      const variantTitle = option.dataset.variantTitle || '';
      addButton.dataset.variantId = option.dataset.variantId || '';
      addButton.dataset.gid = option.dataset.variantGid || `gid://shopify/ProductVariant/${option.dataset.variantId || ''}`;
      addButton.dataset.price = option.dataset.variantPrice || '';
      addButton.dataset.compareAtPrice = option.dataset.variantCompareAtPrice || option.dataset.variantPrice || '';
      addButton.dataset.image = option.dataset.variantImage || '';
      addButton.dataset.available = option.dataset.variantAvailable || 'false';
      addButton.dataset.title = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;
      addButton.disabled = option.dataset.variantAvailable !== 'true';
    }

    selectVariant(card, option) {
      const options = card.querySelectorAll('[data-variant-option]');
      const variantNameEl = card.querySelector('[data-variant-name]');
      const priceEl = card.querySelector('[data-product-price]');
      const inventoryEl = card.querySelector('[data-product-inventory]');
      const atcButton = card.querySelector('[data-atc-button]');
      const productLinks = card.querySelectorAll('[data-product-link]');
      const productTitleLink = card.querySelector('.yg-image-parts__product-title-link');

      const variantId = option.dataset.variantId;
      const variantTitle = option.dataset.variantTitle;
      const variantPriceHtml = option.dataset.variantPriceHtml;
      const variantUrl = option.dataset.variantUrl;
      const variantAvailable = option.dataset.variantAvailable === 'true';

      options.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');

      if (variantNameEl) {
        variantNameEl.textContent = variantTitle;
      }

      if (priceEl && variantPriceHtml) {
        priceEl.innerHTML = variantPriceHtml;
      }

      productLinks.forEach((link) => {
        link.setAttribute('href', variantUrl);
      });

      this.syncAddButtonByVariant(atcButton, option, productTitleLink?.textContent?.trim() || '');

      const inStockLabel = card.dataset.inStockLabel || 'In stock';
      const soldOutLabel = atcButton?.dataset.soldOutLabel || card.dataset.soldOutLabel || 'Sold out';
      const quickAddLabel = atcButton?.dataset.quickAddLabel || 'Quick Add';

      if (inventoryEl) {
        inventoryEl.textContent = variantAvailable ? inStockLabel : soldOutLabel;
        inventoryEl.classList.toggle('is-in-stock', variantAvailable);
        inventoryEl.classList.toggle('is-sold-out', !variantAvailable);
      }

      if (atcButton) {
        atcButton.textContent = variantAvailable ? quickAddLabel : soldOutLabel;
      }

      this.closeAllDropdowns();
    }
  }

  if (!customElements.get('yg-image-parts-scroll')) {
    customElements.define('yg-image-parts-scroll', YGImagePartsScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-parts"] && !Shopify.designMode) return;
  try {
    
  class YGImageParts extends YGUtils {
    constructor() {
      super();
      this._currentIndex = 0;
    }

    connectedCallback() {
      this._trigger  = this.querySelector('.yg-image-parts__dropdown-trigger');
      this._label    = this.querySelector('.yg-image-parts__dropdown-label');
      this._list     = this.querySelector('.yg-image-parts__dropdown-list');
      this._options  = this.querySelectorAll('.yg-image-parts__dropdown-option');
      this._panels   = this.querySelectorAll('.yg-image-parts__panel');
      this._imgs     = this.querySelectorAll('.yg-image-parts__img-item');

      if (this._trigger) {
        this._trigger.addEventListener('click', this._onTriggerClick.bind(this));
        this._trigger.addEventListener('keydown', this._onTriggerKeydown.bind(this));
      }

      this._options.forEach((opt) => {
        opt.addEventListener('click', () => {
          this._selectOption(Number(opt.dataset.index));
          this._closeDropdown();
        });
      });

      document.addEventListener('click', this._onDocClick.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick.bind(this));
    }

    _onTriggerClick() {
      this._list.classList.contains('is-open') ? this._closeDropdown() : this._openDropdown();
    }

    _onTriggerKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._list.classList.contains('is-open') ? this._closeDropdown() : this._openDropdown();
      }
      if (e.key === 'Escape') this._closeDropdown();
    }

    _onDocClick(e) {
      if (!this.contains(e.target)) this._closeDropdown();
    }

    _openDropdown() {
      this._trigger.classList.add('is-open');
      this._list.classList.add('is-open');
      this._trigger.setAttribute('aria-expanded', 'true');
    }

    _closeDropdown() {
      if (!this._trigger) return;
      this._trigger.classList.remove('is-open');
      this._list.classList.remove('is-open');
      this._trigger.setAttribute('aria-expanded', 'false');
    }

    _selectOption(index) {
      var idx = String(index);

      // Update panels
      this._panels.forEach((p) => {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === idx);
      });

      // Update images and trigger lazy load
      this._imgs.forEach((item) => {
        var isActive = item.getAttribute('data-img') === idx;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.querySelectorAll('img[data-src]').forEach((img) => {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          });
        }
      });

      // Update dropdown options
      this._options.forEach((o) => {
        var sel = o.getAttribute('data-index') === idx;
        o.classList.toggle('is-selected', sel);
        o.setAttribute('aria-selected', String(sel));
        if (sel && this._label) this._label.textContent = o.textContent;
      });

      this._currentIndex = index;
    }
  }

  if (!customElements.get('yg-image-parts')) {
    customElements.define('yg-image-parts', YGImageParts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-parts-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGPartsTabs extends YGUtils {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-accessory-panel]'));
      this.medias = Array.from(this.querySelectorAll('[data-accessory-media]'));
      this.slides = Array.from(this.querySelectorAll('[data-accessory-slide]'));

      this.pcRailSwiperEl = this.querySelector('[data-rail-swiper-pc]');
      this.pcPrevEl = this.querySelector('[data-rail-prev-pc]');
      this.pcNextEl = this.querySelector('[data-rail-next-pc]');

      this.isSyncingBySwiper = false;
      this.pcRailSwiper = null;
      this.activeAccessoryIndex = 0;

      this.initRailSwipers();
      this.bindEvents();

      const firstActiveIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.activeAccessoryIndex = firstActiveIndex > -1 ? firstActiveIndex : 0;
      this.activateAccessory(this.activeAccessoryIndex, true);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.pcRailSwiper) return;
          this.pcRailSwiper.update();
          this.pcRailSwiper.slideToLoop(this.activeAccessoryIndex, 0, false);
        });
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.pcRailSwiper) {
        this.pcRailSwiper.destroy(true, true);
        this.pcRailSwiper = null;
      }
    }

    initRailSwipers() {
      this.initPcRailSwiper();
    }

    initPcRailSwiper() {
      if (!this.pcRailSwiperEl || typeof Swiper === 'undefined') return;

      const slideCount = Number(this.pcRailSwiperEl.dataset.slideCount || 0);

      const isSimpleMode = slideCount <= 3;

      // 👉 小于等于3：直接禁用 swiper（推荐）
      if (isSimpleMode) {
        this.pcRailSwiperEl.classList.add('is-simple');
        this.pcRailSwiper = null;

        // 隐藏按钮
        if (this.pcPrevEl) this.pcPrevEl.style.display = 'none';
        if (this.pcNextEl) this.pcNextEl.style.display = 'none';

        return;
      }

      // 👉 正常 swiper 模式
      this.pcRailSwiper = new Swiper(this.pcRailSwiperEl, {
        direction: 'vertical',
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 16,

        centeredSlides: true,
        loop: true,

        centeredSlidesBounds: false,
        watchOverflow: true,

        navigation: {
          prevEl: this.pcPrevEl,
          nextEl: this.pcNextEl,
        },
      });

      this.pcRailSwiper.on('slideChange', () => {
        this.isSyncingBySwiper = true;
        this.activateAccessory(this.pcRailSwiper.realIndex, false);
        this.isSyncingBySwiper = false;
      });
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const slideButton = event.target.closest('[data-accessory-slide]');
        if (slideButton && this.contains(slideButton)) {
          const accessoryIndex = Number(slideButton.dataset.accessorySlide || 0);
          this.activateAccessory(accessoryIndex, true);
          return;
        }

        const variantButton = event.target.closest('[data-variant-tab]');
        if (variantButton) {
          this.handleVariantChange(variantButton);
          return;
        }

        const addButton = event.target.closest('[data-add-button]');
        if (addButton) {
          event.preventDefault();
          this.handleAddButton(addButton);
        }
      });
    }

    activateAccessory(accessoryIndex, syncSwiper = true) {
      this.activeAccessoryIndex = accessoryIndex;

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', Number(panel.dataset.accessoryPanel) === accessoryIndex);
      });

      this.medias.forEach((media) => {
        media.classList.toggle('is-active', Number(media.dataset.accessoryMedia) === accessoryIndex);
      });

      this.slides.forEach((slide) => {
        slide.classList.toggle('is-active', Number(slide.dataset.accessorySlide) === accessoryIndex);
      });

      if (syncSwiper && !this.isSyncingBySwiper && this.pcRailSwiper) {
        this.pcRailSwiper.slideToLoop(accessoryIndex);
      }
    }

    async handleAddButton(addButton) {
      if (!addButton || addButton.disabled) return;

      const payload = this.buildBundlePayload(addButton);
      if (!payload.variantId || payload.available === false) return;

      const bundleApi = window.YGBundleBuilderBarV1External;

      try {
        if (bundleApi && typeof bundleApi.addAccessory === 'function') {
          await bundleApi.addAccessory(payload);
          return;
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(payload.variantId),
            quantity: Number(payload.quantity || 1),
          }),
        });
      } catch (_) {}
    }

    buildBundlePayload(addButton) {
      return {
        productId: addButton.dataset.bundleProductId || '',
        variantId: addButton.dataset.variantId || '',
        gid: addButton.dataset.gid || `gid://shopify/ProductVariant/${addButton.dataset.variantId || ''}`,
        title: addButton.dataset.title || '',
        image: addButton.dataset.image || '',
        price: addButton.dataset.price || '',
        compareAtPrice: addButton.dataset.compareAtPrice || addButton.dataset.price || '',
        available: addButton.dataset.available === 'true',
        quantity: Number(addButton.dataset.quantity || 1),
      };
    }

    syncAddButtonByVariant(addButton, button) {
      if (!addButton || !button) return;

      const productTitle = addButton.dataset.productTitle || '';
      const variantTitle = button.dataset.variantTitle || '';
      const variantAvailable = button.dataset.variantAvailable === 'true';
      const quickAddLabel = addButton.dataset.quickAddLabel || 'Quick Add';
      const soldOutLabel = addButton.dataset.soldOutLabel || 'Sold Out';

      addButton.dataset.variantId = button.dataset.variantId || '';
      addButton.dataset.gid = button.dataset.variantGid || `gid://shopify/ProductVariant/${button.dataset.variantId || ''}`;
      addButton.dataset.price = button.dataset.variantPrice || '';
      addButton.dataset.compareAtPrice = button.dataset.variantCompareAtPrice || button.dataset.variantPrice || '';
      addButton.dataset.image = button.dataset.variantImage || '';
      addButton.dataset.available = button.dataset.variantAvailable || 'false';
      addButton.dataset.title = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;
      addButton.disabled = !variantAvailable;
      addButton.textContent = variantAvailable ? quickAddLabel : soldOutLabel;
    }

    handleVariantChange(button) {
      const accessoryIndex = Number(button.dataset.accessoryIndex || 0);
      const variantIndex = Number(button.dataset.variantIndex || 0);
      const priceHtml = button.dataset.priceHtml || '';

      const panel = this.querySelector(`[data-accessory-panel='${accessoryIndex}']`);
      const mediaPanel = this.querySelector(`[data-accessory-media='${accessoryIndex}']`);

      if (!panel || !mediaPanel) return;

      panel.querySelectorAll('[data-variant-tab]').forEach((tab) => {
        tab.classList.toggle('is-active', tab === button);
      });

      mediaPanel.querySelectorAll('[data-variant-image]').forEach((imageItem) => {
        imageItem.classList.toggle('is-active', Number(imageItem.dataset.variantImage) === variantIndex);
      });

      const priceWrap = panel.querySelector('[data-price-wrap]');
      if (priceWrap) priceWrap.innerHTML = priceHtml;

      const addButton = panel.querySelector('[data-add-button]');
      if (addButton) {
        this.syncAddButtonByVariant(addButton, button);
      }
    }
  }

  if (!customElements.get('yg-parts-tabs')) {
    customElements.define('yg-parts-tabs', YGPartsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-scene-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGProductTabsV2 extends HTMLElement {
    connectedCallback() {
      this.initTabStateWatcher();
      this.initMainMedia();
      this.initScenarioSwitcher();
      this.initAddAllButton();
      this.initAccessorySwipers();

      setTimeout(() => {
        this.switchToScenario(this.currentScenario || '1');
      }, 0);
    }

    initTabStateWatcher() {
      this.tabContentEl = this.closest('.tab-content');
      this.isTabActive = !this.tabContentEl || this.tabContentEl.classList.contains('is-active');

      if (!this.tabContentEl || typeof MutationObserver === 'undefined') return;

      this.tabStateObserver = new MutationObserver(() => {
        const isActiveNow = this.tabContentEl.classList.contains('is-active');
        if (isActiveNow === this.isTabActive) return;

        this.isTabActive = isActiveNow;
        if (this.isTabActive) {
          this.handleTabActivated();
        } else {
          this.handleTabDeactivated();
        }
      });

      this.tabStateObserver.observe(this.tabContentEl, { attributes: true, attributeFilter: ['class'] });
    }

    initMainMedia() {
      const mediaContainers = this.querySelectorAll('[data-scenario-media]');
      if (!mediaContainers.length || typeof Swiper === 'undefined') return;

      this.swipers = {};

      mediaContainers.forEach((container) => {
        const scenarioIndex = container.dataset.scenarioMedia;
        const swiperEl = container.querySelector('[data-main-media-swiper]');
        if (!swiperEl) return;

        const prevEl = container.querySelector('.yg-main-media-prev');
        const nextEl = container.querySelector('.yg-main-media-next');

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            prevEl,
            nextEl,
          },
        });

        this.swipers[scenarioIndex] = swiper;

        swiper.on('slideChange', () => {
          if (this.currentScenario === scenarioIndex) {
            this.handleSlideMediaChange();
            this.restartMediaTimer();
          }
        });
      });

      const activeContainer = this.querySelector('[data-scenario-media]:not([hidden])');
      if (activeContainer) {
        const activeSwiper = activeContainer.querySelector('[data-main-media-swiper]');
        if (activeSwiper && activeSwiper.swiper) {
          this.mainMediaSwiper = activeSwiper.swiper;
        }
      }

      this.mainMediaProgressBar = this.querySelector('[data-main-media-progress-bar]');
      this.imageSwitchSeconds = Number(this.dataset.imageSwitchSeconds || 5);
      this.autoplayInViewport = this.dataset.autoplayInView === 'true';
      this.showScenario2 = this.dataset.showScenario2;
      this.progressRafId = null;
      this.progressStart = 0;
      this.progressDuration = 0;
      this.isAutoplayRunning = false;
      this.isInViewport = !this.autoplayInViewport;

      if (this.autoplayInViewport && 'IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isInViewport = entry.isIntersecting;

              if (this.isInViewport) {
                this.handleSlideMediaChange();
                this.restartMediaTimer();
              } else {
                this.stopMediaTimer();
              }
            });
          },
          { threshold: 0.35 }
        );

        this.viewportObserver.observe(this);
      }

      if (!this.autoplayInViewport && this.isTabActive !== false) {
        this.handleSlideMediaChange();
        this.restartMediaTimer();
      }
    }

    handleTabActivated() {
      this.resetMainMediaToStart();
      this.handleSlideMediaChange();
      this.restartMediaTimer();
    }

    handleTabDeactivated() {
      this.stopMediaTimer();
      this.pauseAllMedia();
    }

    handleSlideMediaChange() {
      this.pauseAllMedia();

      if (!this.mainMediaSwiper) return;
      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector('video');
      if (activeVideo) {
        activeVideo.currentTime = 0;
        const playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    pauseAllMedia() {
      this.querySelectorAll('[data-main-media-swiper] video').forEach((videoEl) => {
        if (!videoEl.paused) {
          videoEl.pause();
        }
        videoEl.currentTime = 0;
      });
    }

    resetMainMediaToStart() {
      if (!this.mainMediaSwiper) return;
      this.mainMediaSwiper.slideTo(0, 0);
    }

    getCurrentSlideDuration() {
      if (!this.mainMediaSwiper) return this.imageSwitchSeconds * 1000;

      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return this.imageSwitchSeconds * 1000;

      const mediaType = activeSlide.dataset.mediaType;
      if (mediaType === 'video' || mediaType === 'external_video') {
        const video = activeSlide.querySelector('video');
        if (video && video.duration && Number.isFinite(video.duration) && video.duration > 0) {
          return video.duration * 1000;
        }
      }

      return this.imageSwitchSeconds * 1000;
    }

    restartMediaTimer() {
      if (!this.mainMediaProgressBar || !this.mainMediaSwiper) return;
      if (this.isTabActive === false) return;
      if (this.autoplayInViewport && !this.isInViewport) return;

      this.stopMediaTimer();
      this.progressDuration = this.getCurrentSlideDuration();
      this.progressStart = performance.now();
      this.isAutoplayRunning = true;

      const tick = (now) => {
        if (!this.isAutoplayRunning) return;

        const elapsed = now - this.progressStart;
        const progress = Math.min(elapsed / this.progressDuration, 1);
        this.mainMediaProgressBar.style.transform = `scaleX(${progress})`;

        if (progress >= 1) {
          this.mainMediaSwiper.slideNext();
          return;
        }

        this.progressRafId = requestAnimationFrame(tick);
      };

      this.mainMediaProgressBar.style.transform = 'scaleX(0)';
      this.progressRafId = requestAnimationFrame(tick);
    }

    stopMediaTimer() {
      this.isAutoplayRunning = false;
      if (this.progressRafId) {
        cancelAnimationFrame(this.progressRafId);
        this.progressRafId = null;
      }
    }

    disconnectedCallback() {
      this.stopMediaTimer();
      this.pauseAllMedia();
      if (this.viewportObserver) {
        this.viewportObserver.disconnect();
      }
      if (this.tabStateObserver) {
        this.tabStateObserver.disconnect();
      }
    }

    initScenarioSwitcher() {
      const scenarioButtons = this.querySelectorAll('[data-scenario-button]');
      if (!scenarioButtons.length) return;

      this.currentScenario = '1';
      const activeButton = this.querySelector('[data-scenario-button].is-active');
      if (activeButton) {
        this.currentScenario = activeButton.dataset.scenarioIndex;
      }

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-scenario-button]');
        if (!button || !this.contains(button)) return;

        const scenarioIndex = button.dataset.scenarioIndex;
        if (scenarioIndex === this.currentScenario) return;

        this.switchToScenario(scenarioIndex);
      });
    }

    switchToScenario(scenarioIndex) {
      this.currentScenario = scenarioIndex;

      const scenarioButtons = this.querySelectorAll('[data-scenario-button]');
      const activeButton = Array.from(scenarioButtons).find((btn) => btn.dataset.scenarioIndex === scenarioIndex);

      scenarioButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.scenarioIndex === scenarioIndex);
      });

      if (activeButton) {
        const descEl = this.querySelector('[data-scenario-desc]');
        if (descEl) {
          descEl.innerHTML = activeButton.dataset.scenarioDescription || '';
        }

        const addAllBtn = this.querySelector('[data-add-all-main]');
        if (addAllBtn) {
          addAllBtn.dataset.scenarioProducts = activeButton.dataset.scenarioProducts || '';
        }

        const priceWrap = this.querySelector('[data-price-wrap]');
        
        if (priceWrap) {
          const priceData = activeButton.dataset.scenarioPrice;
          
          const comparePriceData = activeButton.dataset.scenarioComparePrice;          
          if (priceData) {
            const salePriceEl = priceWrap.querySelector('sale-price');

            if (salePriceEl) {
              salePriceEl.textContent = priceData;
            }
            const comparePriceEl = priceWrap.querySelector('compare-at-price');
            if (comparePriceEl) {
              if (comparePriceData) {
                comparePriceEl.textContent = comparePriceData;
                comparePriceEl.style.display = 'block';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          }
        }
      }

      if(this.showScenario2) {
        const allMediaContainers = this.querySelectorAll('[data-scenario-media]');
        allMediaContainers.forEach((container) => {
          const mediaScenario = container.dataset.scenarioMedia;
          container.hidden = mediaScenario !== scenarioIndex;
        });
      }

      const allAccessoryGroups = this.querySelectorAll('[data-scenario-accessories]');
      allAccessoryGroups.forEach((group) => {
        const groupScenario = group.dataset.scenarioAccessories;
        group.hidden = groupScenario !== scenarioIndex;
      });

      const allLearnMoreWrappers = this.querySelectorAll('[data-scenario-learn-more]');
      allLearnMoreWrappers.forEach((wrapper) => {
        const wrapperScenario = wrapper.dataset.scenarioLearnMore;
        wrapper.hidden = wrapperScenario !== scenarioIndex;
      });

      if(this.showScenario2) {
            this.stopMediaTimer();
            this.pauseAllMedia();

            const activeMediaContainer = this.querySelector(`[data-scenario-media="${scenarioIndex}"]`);
            if (activeMediaContainer) {
              const activeSwiper = activeMediaContainer.querySelector('[data-main-media-swiper]');
              if (activeSwiper && activeSwiper.swiper) {
                activeSwiper.swiper.slideTo(0, 0);
                this.mainMediaSwiper = activeSwiper.swiper;
                this.handleSlideMediaChange();
                  this.restartMediaTimer();

              }
            }
      }
      if (this.accessorySwipers && this.accessorySwipers.length) {
        setTimeout(() => {
          this.accessorySwipers.forEach((swiper) => {
            if (swiper && swiper.update) {
              swiper.update();
            }
          });
        }, 100);
      }
    }

    initAddAllButton() {
      const addAllBtn = this.querySelector('[data-add-all-main]');
      if (!addAllBtn) return;

      addAllBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        const productsData = addAllBtn.dataset.scenarioProducts;
        if (!productsData) return;

        const variantIds = productsData
          .split(',')
          .filter(Boolean)
          .map((id) => {
            const trimmedId = id.trim();
            return trimmedId ? Number(trimmedId) : null;
          })
          .filter(Boolean);

        if (!variantIds.length) return;

        const items = variantIds.map((variantId) => ({
          id: variantId,
          quantity: 1,
        }));
        await this.addItemsToCart(items, addAllBtn);
      });
    }

    async addItemsToCart(items = [], triggerButton = null) {
      if (!items.length) return;

      const wasDisabled = triggerButton ? triggerButton.disabled : false;
      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.setAttribute('aria-busy', 'true');
      }

      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const bundledSections = Array.from(new Set(sectionsToBundle.filter(Boolean)));
      const currentVariantId = items[0].id;
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items,
          sections: bundledSections.join(','),
          sections_url: `${Shopify.routes.root}variants/${currentVariantId}`,
        }),
      });

      try {
        const responseJson = await response.json();
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections || {};

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } finally {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.disabled = wasDisabled;
        }
      }
    }

    initAccessorySwipers() {
      const groups = Array.from(this.querySelectorAll('[data-accessory-group]'));
      if (!groups.length || typeof Swiper === 'undefined') return;

      this.accessorySwipers = [];

      groups.forEach((group) => {
        const swiperEl = group.querySelector('[data-accessory-swiper]');
        const prevEl = group.querySelector('[data-accessory-prev]');
        const nextEl = group.querySelector('[data-accessory-next]');
        const countEl = group.querySelector('[data-accessory-count]');
        if (!swiperEl) return;

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: countEl,
            type: 'fraction',
            formatFractionCurrent: (number) => (number < 10 ? `0${number}` : `${number}`),
            formatFractionTotal: (number) => (number < 10 ? `0${number}` : `${number}`),
          },
          breakpoints: {
            1000: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        });

        this.accessorySwipers.push(swiper);
      });
    }
  }

  if (!customElements.get('yg-product-tabs-v2')) {
    customElements.define('yg-product-tabs-v2', YGProductTabsV2);
  }

  class YGProductTabsPopup extends HTMLElement {
    connectedCallback() {
      this.initModalSwiper();
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.modalResizeHandler) {
        window.removeEventListener('resize', this.modalResizeHandler);
      }
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const addVariantBtn = event.target.closest('[data-add-variant]');
        if (addVariantBtn && this.contains(addVariantBtn)) {
          event.preventDefault();
          const variantId = addVariantBtn.dataset.variantId || '';
          if (variantId) {
            this.addItemsToCart([{ id: Number(variantId), quantity: 1 }], addVariantBtn);
          }
          return;
        }

        const addAllBtn = event.target.closest('[data-add-all-popup-products]');
        if (addAllBtn && this.contains(addAllBtn)) {
          event.preventDefault();
          this.handleAddAllProducts(addAllBtn);
          return;
        }

        const prevBtn = event.target.closest('[data-modal-prev]');
        if (prevBtn && this.contains(prevBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage - 1);
          return;
        }

        const nextBtn = event.target.closest('[data-modal-next]');
        if (nextBtn && this.contains(nextBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage + 1);
        }
      });
    }

    initModalSwiper() {
      this.modalItems = Array.from(this.querySelectorAll('[data-modal-product-item]'));
      this.modalPageCountEl = this.querySelector('[data-modal-page-count]');
      this.modalPrevEl = this.querySelector('[data-modal-prev]');
      this.modalNextEl = this.querySelector('[data-modal-next]');
      this.modalPaginationEl = this.querySelector('.yg-modal-pagination');
      this.currentPage = 1;

      this.modalResizeHandler = this.updateModalPagination.bind(this);
      window.addEventListener('resize', this.modalResizeHandler);
      this.updateModalPagination();
    }

    getModalPerPage() {
      return window.innerWidth >= 1000 ? 3 : 2;
    }

    updateModalPagination() {
      if (!this.modalPageCountEl || !this.modalItems?.length) {
        if (this.modalPaginationEl) {
          this.modalPaginationEl.classList.add('is-hidden');
        }
        return;
      }

      const perPage = this.getModalPerPage();
      const totalPages = Math.max(1, Math.ceil(this.modalItems.length / perPage));
      this.currentPage = Math.min(Math.max(this.currentPage || 1, 1), totalPages);

      this.modalItems.forEach((item, index) => {
        const pageIndex = Math.floor(index / perPage) + 1;
        item.hidden = pageIndex !== this.currentPage;
      });

      if (this.modalPaginationEl) {
        this.modalPaginationEl.classList.toggle('is-hidden', totalPages <= 1);
      }

      this.modalPageCountEl.textContent = `${String(this.currentPage).padStart(2, '0')} / ${String(totalPages).padStart(
        2,
        '0'
      )}`;

      if (this.modalPrevEl) {
        this.modalPrevEl.disabled = this.currentPage <= 1;
      }

      if (this.modalNextEl) {
        this.modalNextEl.disabled = this.currentPage >= totalPages;
      }
    }

    goToPage(page) {
      this.currentPage = page;
      this.updateModalPagination();
    }

    handleAddAllProducts(triggerButton = null) {
      const itemsMap = new Map();
      const popupItems = Array.from(this.querySelectorAll('[data-popup-item]'));

      popupItems.forEach((item) => {
        if (item.dataset.available !== 'true') return;
        const variantId = item.dataset.variantId || '';
        if (!variantId) return;

        const key = String(variantId);
        itemsMap.set(key, (itemsMap.get(key) || 0) + 1);
      });

      const items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id: Number(id), quantity }));
      if (items.length) {
        this.addItemsToCart(items, triggerButton);
      }
    }

    async addItemsToCart(items = [], triggerButton = null) {
      if (!items.length) return;

      const wasDisabled = triggerButton ? triggerButton.disabled : false;
      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.setAttribute('aria-busy', 'true');
      }

      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const bundledSections = Array.from(new Set(sectionsToBundle.filter(Boolean)));
      const currentVariantId = items[0].id;
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items,
          sections: bundledSections.join(','),
          sections_url: `${Shopify.routes.root}variants/${currentVariantId}`,
        }),
      });

      try {
        const responseJson = await response.json();
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections || {};

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } finally {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.disabled = wasDisabled;
        }
      }
    }
  }

  if (!customElements.get('yg-product-tabs-popup')) {
    customElements.define('yg-product-tabs-popup', YGProductTabsPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tabs-backup"] && !Shopify.designMode) return;
  try {
    
  class YGProductTabsV2 extends HTMLElement {
    connectedCallback() {
      this.initTabStateWatcher();
      this.initMainMedia();
      this.initVariantSwitcher();
      this.initAccessorySwipers();
    }

    initTabStateWatcher() {
      this.tabContentEl = this.closest('.tab-content');
      this.isTabActive = !this.tabContentEl || this.tabContentEl.classList.contains('is-active');

      if (!this.tabContentEl || typeof MutationObserver === 'undefined') return;

      this.tabStateObserver = new MutationObserver(() => {
        const isActiveNow = this.tabContentEl.classList.contains('is-active');
        if (isActiveNow === this.isTabActive) return;

        this.isTabActive = isActiveNow;
        if (this.isTabActive) {
          this.handleTabActivated();
        } else {
          this.handleTabDeactivated();
        }
      });

      this.tabStateObserver.observe(this.tabContentEl, { attributes: true, attributeFilter: ['class'] });
    }

    initMainMedia() {
      const el = this.querySelector('[data-main-media-swiper]');
      if (!el || typeof Swiper === 'undefined') return;

      const prevEl = this.querySelector('.yg-main-media-prev');
      const nextEl = this.querySelector('.yg-main-media-next');

      this.mainMediaSwiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          prevEl,
          nextEl,
        },
      });

      this.mainMediaProgressBar = this.querySelector('[data-main-media-progress-bar]');
      this.imageSwitchSeconds = Number(this.dataset.imageSwitchSeconds || 5);
      this.autoplayInViewport = this.dataset.autoplayInView === 'true';
      this.progressRafId = null;
      this.progressStart = 0;
      this.progressDuration = 0;
      this.isAutoplayRunning = false;
      this.isInViewport = !this.autoplayInViewport;

      this.mainMediaSwiper.on('slideChange', () => {
        this.handleSlideMediaChange();
        this.restartMediaTimer();
      });

      if (this.autoplayInViewport && 'IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isInViewport = entry.isIntersecting;

              if (this.isInViewport) {
                this.handleSlideMediaChange();
                this.restartMediaTimer();
              } else {
                this.stopMediaTimer();
              }
            });
          },
          { threshold: 0.35 }
        );

        this.viewportObserver.observe(this);
      }

      if (!this.autoplayInViewport && this.isTabActive !== false) {
        this.handleSlideMediaChange();
        this.restartMediaTimer();
      }
    }

    handleTabActivated() {
      this.resetMainMediaToStart();
      this.handleSlideMediaChange();
      this.restartMediaTimer();
    }

    handleTabDeactivated() {
      this.stopMediaTimer();
      this.pauseAllMedia();
    }

    handleSlideMediaChange() {
      this.pauseAllMedia();

      if (!this.mainMediaSwiper) return;
      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector('video');
      if (activeVideo) {
        activeVideo.currentTime = 0;
        const playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    pauseAllMedia() {
      this.querySelectorAll('[data-main-media-swiper] video').forEach((videoEl) => {
        if (!videoEl.paused) {
          videoEl.pause();
        }
        videoEl.currentTime = 0;
      });
    }

    resetMainMediaToStart() {
      if (!this.mainMediaSwiper) return;
      this.mainMediaSwiper.slideTo(0, 0);
    }

    getCurrentSlideDuration() {
      if (!this.mainMediaSwiper) return this.imageSwitchSeconds * 1000;

      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return this.imageSwitchSeconds * 1000;

      const mediaType = activeSlide.dataset.mediaType;
      if (mediaType === 'video' || mediaType === 'external_video') {
        const video = activeSlide.querySelector('video');
        if (video && video.duration && Number.isFinite(video.duration) && video.duration > 0) {
          return video.duration * 1000;
        }
      }

      return this.imageSwitchSeconds * 1000;
    }

    restartMediaTimer() {
      if (!this.mainMediaProgressBar || !this.mainMediaSwiper) return;
      if (this.isTabActive === false) return;
      if (this.autoplayInViewport && !this.isInViewport) return;

      this.stopMediaTimer();
      this.progressDuration = this.getCurrentSlideDuration();
      this.progressStart = performance.now();
      this.isAutoplayRunning = true;

      const tick = (now) => {
        if (!this.isAutoplayRunning) return;

        const elapsed = now - this.progressStart;
        const progress = Math.min(elapsed / this.progressDuration, 1);
        this.mainMediaProgressBar.style.transform = `scaleX(${progress})`;

        if (progress >= 1) {
          this.mainMediaSwiper.slideNext();
          return;
        }

        this.progressRafId = requestAnimationFrame(tick);
      };

      this.mainMediaProgressBar.style.transform = 'scaleX(0)';
      this.progressRafId = requestAnimationFrame(tick);
    }

    stopMediaTimer() {
      this.isAutoplayRunning = false;
      if (this.progressRafId) {
        cancelAnimationFrame(this.progressRafId);
        this.progressRafId = null;
      }
    }

    disconnectedCallback() {
      this.stopMediaTimer();
      this.pauseAllMedia();
      if (this.viewportObserver) {
        this.viewportObserver.disconnect();
      }
      if (this.tabStateObserver) {
        this.tabStateObserver.disconnect();
      }
    }

    initVariantSwitcher() {
      const optionButtons = Array.from(this.querySelectorAll('[data-variant-button]'));
      if (!optionButtons.length) return;

      const remarkEl = this.querySelector('[data-variant-remark]');
      const descEl = this.querySelector('[data-variant-desc]');
      const priceWrap = this.querySelector('[data-price-wrap]');
      const form = this.querySelector('form[is="product-form"]');
      const variantInput = form ? form.querySelector('input[name="id"]') : null;
      const submitBtn = form ? form.querySelector('button[type="submit"]') : null;
      const paymentBtn = form ? form.querySelector('.shopify-payment-button') : null;
      const variantTitleEl = this.querySelector('[data-variant-title]');
      const infoWrap = this.querySelector('[data-main-info]');
      const atcLabel = infoWrap?.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = infoWrap?.dataset.soldoutLabel || 'Sold out';

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-variant-button]');
        if (!button || !this.contains(button)) return;

        optionButtons.forEach((item) => item.classList.toggle('is-active', item === button));

        if (remarkEl) remarkEl.innerHTML = button.dataset.variantRemarkHtml || '';
        if (descEl) descEl.innerHTML = button.dataset.variantDescHtml || '';

        if (priceWrap && button.dataset.variantPriceHtml) {
          priceWrap.innerHTML = button.dataset.variantPriceHtml;
        }

        if (variantTitleEl) {
          const nextTitle = button.dataset.variantTitle || '';
          variantTitleEl.textContent = nextTitle === 'Default Title' ? '' : nextTitle;
        }

        if (variantInput) {
          variantInput.value = button.dataset.variantId || '';
        }

        const isAvailable = button.dataset.variantAvailable === 'true';
        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          submitBtn.textContent = isAvailable ? atcLabel : soldoutLabel;
        }

        if (paymentBtn) {
          paymentBtn.style.display = isAvailable ? '' : 'none';
        }
      });
    }

    initAccessorySwipers() {
      const groups = Array.from(this.querySelectorAll('[data-accessory-group]'));
      if (!groups.length || typeof Swiper === 'undefined') return;

      groups.forEach((group) => {
        const swiperEl = group.querySelector('[data-accessory-swiper]');
        const prevEl = group.querySelector('[data-accessory-prev]');
        const nextEl = group.querySelector('[data-accessory-next]');
        const countEl = group.querySelector('[data-accessory-count]');
        if (!swiperEl) return;

        new Swiper(swiperEl, {
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: countEl,
            type: 'fraction',
            formatFractionCurrent: (number) => (number < 10 ? `0${number}` : `${number}`),
            formatFractionTotal: (number) => (number < 10 ? `0${number}` : `${number}`),
          },
          breakpoints: {
            1000: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        });
      });
    }
  }

  if (!customElements.get('yg-product-tabs-v2')) {
    customElements.define('yg-product-tabs-v2', YGProductTabsV2);
  }

  class YGProductTabsPopup extends HTMLElement {
    connectedCallback() {
      this.initModalSwiper();
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.modalResizeHandler) {
        window.removeEventListener('resize', this.modalResizeHandler);
      }
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const addVariantBtn = event.target.closest('[data-add-variant]');
        if (addVariantBtn && this.contains(addVariantBtn)) {
          event.preventDefault();
          const variantId = addVariantBtn.dataset.variantId || '';
          if (variantId) {
            this.addItemsToCart([{ id: Number(variantId), quantity: 1 }], addVariantBtn);
          }
          return;
        }

        const addAllBtn = event.target.closest('[data-add-all-popup-products]');
        if (addAllBtn && this.contains(addAllBtn)) {
          event.preventDefault();
          this.handleAddAllProducts(addAllBtn);
          return;
        }

        const prevBtn = event.target.closest('[data-modal-prev]');
        if (prevBtn && this.contains(prevBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage - 1);
          return;
        }

        const nextBtn = event.target.closest('[data-modal-next]');
        if (nextBtn && this.contains(nextBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage + 1);
        }
      });
    }

    initModalSwiper() {
      this.modalItems = Array.from(this.querySelectorAll('[data-modal-product-item]'));
      this.modalPageCountEl = this.querySelector('[data-modal-page-count]');
      this.modalPrevEl = this.querySelector('[data-modal-prev]');
      this.modalNextEl = this.querySelector('[data-modal-next]');
      this.modalPaginationEl = this.querySelector('.yg-modal-pagination');
      this.currentPage = 1;

      this.modalResizeHandler = this.updateModalPagination.bind(this);
      window.addEventListener('resize', this.modalResizeHandler);
      this.updateModalPagination();
    }

    getModalPerPage() {
      return window.innerWidth >= 1000 ? 3 : 2;
    }

    updateModalPagination() {
      if (!this.modalPageCountEl || !this.modalItems?.length) {
        if (this.modalPaginationEl) {
          this.modalPaginationEl.classList.add('is-hidden');
        }
        return;
      }

      const perPage = this.getModalPerPage();
      const totalPages = Math.max(1, Math.ceil(this.modalItems.length / perPage));
      this.currentPage = Math.min(Math.max(this.currentPage || 1, 1), totalPages);

      this.modalItems.forEach((item, index) => {
        const pageIndex = Math.floor(index / perPage) + 1;
        item.hidden = pageIndex !== this.currentPage;
      });

      if (this.modalPaginationEl) {
        this.modalPaginationEl.classList.toggle('is-hidden', totalPages <= 1);
      }

      this.modalPageCountEl.textContent = `${String(this.currentPage).padStart(2, '0')} / ${String(totalPages).padStart(
        2,
        '0'
      )}`;

      if (this.modalPrevEl) {
        this.modalPrevEl.disabled = this.currentPage <= 1;
      }

      if (this.modalNextEl) {
        this.modalNextEl.disabled = this.currentPage >= totalPages;
      }
    }

    goToPage(page) {
      this.currentPage = page;
      this.updateModalPagination();
    }

    handleAddAllProducts(triggerButton = null) {
      const itemsMap = new Map();
      const popupItems = Array.from(this.querySelectorAll('[data-popup-item]'));

      popupItems.forEach((item) => {
        if (item.dataset.available !== 'true') return;
        const variantId = item.dataset.variantId || '';
        if (!variantId) return;

        const key = String(variantId);
        itemsMap.set(key, (itemsMap.get(key) || 0) + 1);
      });

      const items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id: Number(id), quantity }));
      if (items.length) {
        this.addItemsToCart(items, triggerButton);
      }
    }

    async addItemsToCart(items = [], triggerButton = null) {
      if (!items.length) return;

      const wasDisabled = triggerButton ? triggerButton.disabled : false;
      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.setAttribute('aria-busy', 'true');
      }

      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const bundledSections = Array.from(new Set(sectionsToBundle.filter(Boolean)));
      const currentVariantId = items[0].id;
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items,
          sections: bundledSections.join(','),
          sections_url: `${Shopify.routes.root}variants/${currentVariantId}`,
        }),
      });

      try {
        const responseJson = await response.json();
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections || {};

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } finally {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.disabled = wasDisabled;
        }
      }
    }
  }

  if (!customElements.get('yg-product-tabs-popup')) {
    customElements.define('yg-product-tabs-popup', YGProductTabsPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGProductTabsV2 extends HTMLElement {
    connectedCallback() {
      this.initTabStateWatcher();
      this.initMainMedia();
      this.initVariantSwitcher();
      this.initAccessorySwipers();
    }

    initTabStateWatcher() {
      this.tabContentEl = this.closest('.tab-content');
      this.isTabActive = !this.tabContentEl || this.tabContentEl.classList.contains('is-active');

      if (!this.tabContentEl || typeof MutationObserver === 'undefined') return;

      this.tabStateObserver = new MutationObserver(() => {
        const isActiveNow = this.tabContentEl.classList.contains('is-active');
        if (isActiveNow === this.isTabActive) return;

        this.isTabActive = isActiveNow;
        if (this.isTabActive) {
          this.handleTabActivated();
        } else {
          this.handleTabDeactivated();
        }
      });

      this.tabStateObserver.observe(this.tabContentEl, { attributes: true, attributeFilter: ['class'] });
    }

    initMainMedia() {
      const el = this.querySelector('[data-main-media-swiper]');
      if (!el || typeof Swiper === 'undefined') return;

      const prevEl = this.querySelector('.yg-main-media-prev');
      const nextEl = this.querySelector('.yg-main-media-next');

      this.mainMediaSwiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          prevEl,
          nextEl,
        },
      });

      this.mainMediaProgressBar = this.querySelector('[data-main-media-progress-bar]');
      this.imageSwitchSeconds = Number(this.dataset.imageSwitchSeconds || 5);
      this.autoplayInViewport = this.dataset.autoplayInView === 'true';
      this.progressRafId = null;
      this.progressStart = 0;
      this.progressDuration = 0;
      this.isAutoplayRunning = false;
      this.isInViewport = !this.autoplayInViewport;

      this.mainMediaSwiper.on('slideChange', () => {
        this.handleSlideMediaChange();
        this.restartMediaTimer();
      });

      if (this.autoplayInViewport && 'IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isInViewport = entry.isIntersecting;

              if (this.isInViewport) {
                this.handleSlideMediaChange();
                this.restartMediaTimer();
              } else {
                this.stopMediaTimer();
              }
            });
          },
          { threshold: 0.35 }
        );

        this.viewportObserver.observe(this);
      }

      if (!this.autoplayInViewport && this.isTabActive !== false) {
        this.handleSlideMediaChange();
        this.restartMediaTimer();
      }
    }

    handleTabActivated() {
      this.resetMainMediaToStart();
      this.handleSlideMediaChange();
      this.restartMediaTimer();
    }

    handleTabDeactivated() {
      this.stopMediaTimer();
      this.pauseAllMedia();
    }

    handleSlideMediaChange() {
      this.pauseAllMedia();

      if (!this.mainMediaSwiper) return;
      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector('video');
      if (activeVideo) {
        activeVideo.currentTime = 0;
        const playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    pauseAllMedia() {
      this.querySelectorAll('[data-main-media-swiper] video').forEach((videoEl) => {
        if (!videoEl.paused) {
          videoEl.pause();
        }
        videoEl.currentTime = 0;
      });
    }

    resetMainMediaToStart() {
      if (!this.mainMediaSwiper) return;
      this.mainMediaSwiper.slideTo(0, 0);
    }

    getCurrentSlideDuration() {
      if (!this.mainMediaSwiper) return this.imageSwitchSeconds * 1000;

      const activeSlide = this.mainMediaSwiper.slides[this.mainMediaSwiper.activeIndex];
      if (!activeSlide) return this.imageSwitchSeconds * 1000;

      const mediaType = activeSlide.dataset.mediaType;
      if (mediaType === 'video' || mediaType === 'external_video') {
        const video = activeSlide.querySelector('video');
        if (video && video.duration && Number.isFinite(video.duration) && video.duration > 0) {
          return video.duration * 1000;
        }
      }

      return this.imageSwitchSeconds * 1000;
    }

    restartMediaTimer() {
      if (!this.mainMediaProgressBar || !this.mainMediaSwiper) return;
      if (this.isTabActive === false) return;
      if (this.autoplayInViewport && !this.isInViewport) return;

      this.stopMediaTimer();
      this.progressDuration = this.getCurrentSlideDuration();
      this.progressStart = performance.now();
      this.isAutoplayRunning = true;

      const tick = (now) => {
        if (!this.isAutoplayRunning) return;

        const elapsed = now - this.progressStart;
        const progress = Math.min(elapsed / this.progressDuration, 1);
        this.mainMediaProgressBar.style.transform = `scaleX(${progress})`;

        if (progress >= 1) {
          this.mainMediaSwiper.slideNext();
          return;
        }

        this.progressRafId = requestAnimationFrame(tick);
      };

      this.mainMediaProgressBar.style.transform = 'scaleX(0)';
      this.progressRafId = requestAnimationFrame(tick);
    }

    stopMediaTimer() {
      this.isAutoplayRunning = false;
      if (this.progressRafId) {
        cancelAnimationFrame(this.progressRafId);
        this.progressRafId = null;
      }
    }

    disconnectedCallback() {
      this.stopMediaTimer();
      this.pauseAllMedia();
      if (this.viewportObserver) {
        this.viewportObserver.disconnect();
      }
      if (this.tabStateObserver) {
        this.tabStateObserver.disconnect();
      }
    }

    initVariantSwitcher() {
      const optionButtons = Array.from(this.querySelectorAll('[data-variant-button]'));
      if (!optionButtons.length) return;

      const remarkEl = this.querySelector('[data-variant-remark]');
      const descEl = this.querySelector('[data-variant-desc]');
      const priceWrap = this.querySelector('[data-price-wrap]');
      const form = this.querySelector('form[is="product-form"]');
      const variantInput = form ? form.querySelector('input[name="id"]') : null;
      const submitBtn = form ? form.querySelector('button[type="submit"]') : null;
      const paymentBtn = form ? form.querySelector('.shopify-payment-button') : null;
      const variantTitleEl = this.querySelector('[data-variant-title]');
      const infoWrap = this.querySelector('[data-main-info]');
      const atcLabel = infoWrap?.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = infoWrap?.dataset.soldoutLabel || 'Sold out';

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-variant-button]');
        if (!button || !this.contains(button)) return;

        optionButtons.forEach((item) => item.classList.toggle('is-active', item === button));

        if (remarkEl) remarkEl.innerHTML = button.dataset.variantRemarkHtml || '';
        if (descEl) descEl.innerHTML = button.dataset.variantDescHtml || '';

        if (priceWrap && button.dataset.variantPriceHtml) {
          priceWrap.innerHTML = button.dataset.variantPriceHtml;
        }

        if (variantTitleEl) {
          const nextTitle = button.dataset.variantTitle || '';
          variantTitleEl.textContent = nextTitle === 'Default Title' ? '' : nextTitle;
        }

        if (variantInput) {
          variantInput.value = button.dataset.variantId || '';
        }

        const isAvailable = button.dataset.variantAvailable === 'true';
        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          submitBtn.textContent = isAvailable ? atcLabel : soldoutLabel;
        }

        if (paymentBtn) {
          paymentBtn.style.display = isAvailable ? '' : 'none';
        }
      });
    }

    initAccessorySwipers() {
      const groups = Array.from(this.querySelectorAll('[data-accessory-group]'));
      if (!groups.length || typeof Swiper === 'undefined') return;

      groups.forEach((group) => {
        const swiperEl = group.querySelector('[data-accessory-swiper]');
        const prevEl = group.querySelector('[data-accessory-prev]');
        const nextEl = group.querySelector('[data-accessory-next]');
        const countEl = group.querySelector('[data-accessory-count]');
        if (!swiperEl) return;

        new Swiper(swiperEl, {
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: countEl,
            type: 'fraction',
            formatFractionCurrent: (number) => (number < 10 ? `0${number}` : `${number}`),
            formatFractionTotal: (number) => (number < 10 ? `0${number}` : `${number}`),
          },
          breakpoints: {
            1000: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        });
      });
    }
  }

  if (!customElements.get('yg-product-tabs-v2')) {
    customElements.define('yg-product-tabs-v2', YGProductTabsV2);
  }

  class YGProductTabsPopup extends HTMLElement {
    connectedCallback() {
      this.initModalSwiper();
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.modalResizeHandler) {
        window.removeEventListener('resize', this.modalResizeHandler);
      }
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const addVariantBtn = event.target.closest('[data-add-variant]');
        if (addVariantBtn && this.contains(addVariantBtn)) {
          event.preventDefault();
          const variantId = addVariantBtn.dataset.variantId || '';
          if (variantId) {
            this.addItemsToCart([{ id: Number(variantId), quantity: 1 }], addVariantBtn);
          }
          return;
        }

        const addAllBtn = event.target.closest('[data-add-all-popup-products]');
        if (addAllBtn && this.contains(addAllBtn)) {
          event.preventDefault();
          this.handleAddAllProducts(addAllBtn);
          return;
        }

        const prevBtn = event.target.closest('[data-modal-prev]');
        if (prevBtn && this.contains(prevBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage - 1);
          return;
        }

        const nextBtn = event.target.closest('[data-modal-next]');
        if (nextBtn && this.contains(nextBtn)) {
          event.preventDefault();
          this.goToPage(this.currentPage + 1);
        }
      });
    }

    initModalSwiper() {
      this.modalItems = Array.from(this.querySelectorAll('[data-modal-product-item]'));
      this.modalPageCountEl = this.querySelector('[data-modal-page-count]');
      this.modalPrevEl = this.querySelector('[data-modal-prev]');
      this.modalNextEl = this.querySelector('[data-modal-next]');
      this.modalPaginationEl = this.querySelector('.yg-modal-pagination');
      this.currentPage = 1;

      this.modalResizeHandler = this.updateModalPagination.bind(this);
      window.addEventListener('resize', this.modalResizeHandler);
      this.updateModalPagination();
    }

    getModalPerPage() {
      return window.innerWidth >= 1000 ? 3 : 2;
    }

    updateModalPagination() {
      if (!this.modalPageCountEl || !this.modalItems?.length) {
        if (this.modalPaginationEl) {
          this.modalPaginationEl.classList.add('is-hidden');
        }
        return;
      }

      const perPage = this.getModalPerPage();
      const totalPages = Math.max(1, Math.ceil(this.modalItems.length / perPage));
      this.currentPage = Math.min(Math.max(this.currentPage || 1, 1), totalPages);

      this.modalItems.forEach((item, index) => {
        const pageIndex = Math.floor(index / perPage) + 1;
        item.hidden = pageIndex !== this.currentPage;
      });

      if (this.modalPaginationEl) {
        this.modalPaginationEl.classList.toggle('is-hidden', totalPages <= 1);
      }

      this.modalPageCountEl.textContent = `${String(this.currentPage).padStart(2, '0')} / ${String(totalPages).padStart(
        2,
        '0'
      )}`;

      if (this.modalPrevEl) {
        this.modalPrevEl.disabled = this.currentPage <= 1;
      }

      if (this.modalNextEl) {
        this.modalNextEl.disabled = this.currentPage >= totalPages;
      }
    }

    goToPage(page) {
      this.currentPage = page;
      this.updateModalPagination();
    }

    handleAddAllProducts(triggerButton = null) {
      const itemsMap = new Map();
      const popupItems = Array.from(this.querySelectorAll('[data-popup-item]'));

      popupItems.forEach((item) => {
        if (item.dataset.available !== 'true') return;
        const variantId = item.dataset.variantId || '';
        if (!variantId) return;

        const key = String(variantId);
        itemsMap.set(key, (itemsMap.get(key) || 0) + 1);
      });

      const items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id: Number(id), quantity }));
      if (items.length) {
        this.addItemsToCart(items, triggerButton);
      }
    }

    async addItemsToCart(items = [], triggerButton = null) {
      if (!items.length) return;

      const wasDisabled = triggerButton ? triggerButton.disabled : false;
      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.setAttribute('aria-busy', 'true');
      }

      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const bundledSections = Array.from(new Set(sectionsToBundle.filter(Boolean)));
      const currentVariantId = items[0].id;
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items,
          sections: bundledSections.join(','),
          sections_url: `${Shopify.routes.root}variants/${currentVariantId}`,
        }),
      });

      try {
        const responseJson = await response.json();
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections || {};

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } finally {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.disabled = wasDisabled;
        }
      }
    }
  }

  if (!customElements.get('yg-product-tabs-popup')) {
    customElements.define('yg-product-tabs-popup', YGProductTabsPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-specifications"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGSpec extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.yg-specs-toggle');
      this.container = this.querySelector('.yg-specs-container');

      if (!this.container) return;

      // 修复 RichText 结构，兼容链接、span、em 等元素
      this.buildSpecColumns();

      if (!this.toggle) return;

      const paragraphs = this.container.querySelectorAll('.yg-specs p');

      // p标签数量 <= 6 时，隐藏按钮
      if (paragraphs.length <= 6) {
        this.toggle.style.display = 'none';
        this.container.classList.remove('collapsed');
        this.container.style.maxHeight = 'none';
        return;
      }

      this.calculateCollapsedHeight(paragraphs);

      this.toggle.addEventListener('click', () => {
        this.handleToggle();
      });

      // 窗口尺寸变化时重新计算高度
      window.addEventListener('resize', () => {
        if (!this.toggle.classList.contains('expanded')) {
          this.calculateCollapsedHeight(paragraphs);
        }
      });
    }

    /**
     * 将 RichText 结构转换为：
     *
     * <p>
     *   <strong>Title</strong>
     *   <div class="yg-specs-value">
     *      内容
     *      <a></a>
     *      <br>
     *   </div>
     * </p>
     */
    buildSpecColumns() {
      const rows = this.querySelectorAll('.yg-specs p');

      rows.forEach((row) => {
        const strong = row.querySelector('strong');

        if (!strong) return;

        // 已处理过
        if (row.querySelector('.yg-specs-value')) return;

        const valueWrapper = document.createElement('div');
        valueWrapper.className = 'yg-specs-value';

        let currentNode = strong.nextSibling;

        while (currentNode) {
          const nextNode = currentNode.nextSibling;
          valueWrapper.appendChild(currentNode);
          currentNode = nextNode;
        }

        row.appendChild(valueWrapper);
      });
    }

    calculateCollapsedHeight(paragraphs) {
      let totalHeight = 0;

      const count = Math.min(6, paragraphs.length);

      for (let i = 0; i < count; i++) {
        totalHeight += paragraphs[i].offsetHeight;
      }

      this.collapsedHeight = totalHeight;
      this.container.style.maxHeight = totalHeight + 'px';
    }

    handleToggle() {
      const isExpanded = this.toggle.classList.contains('expanded');

      if (isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.toggle.classList.remove('collapsed');
      this.toggle.classList.add('expanded');

      this.container.classList.remove('collapsed');
      this.container.classList.add('expanded');

      this.container.style.maxHeight = 'none';

      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.querySelector('span').textContent = 'See less';
    }

    collapse() {
      this.toggle.classList.remove('expanded');
      this.toggle.classList.add('collapsed');

      this.container.classList.remove('expanded');
      this.container.classList.add('collapsed');

      this.container.style.maxHeight = this.collapsedHeight + 'px';

      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.querySelector('span').textContent = 'See more';
    }
  }

  if (!customElements.get('yg-spec')) {
    customElements.define('yg-spec', YGSpec);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-steps-collapse"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl
      let isMobile = window.innerWidth < 699;

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': isMobile ? this.querySelectorAll('.yg-process-steps-content-media') : this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth < 699;
      if (isMobile) {
        return id.replace('steps-item-', 'steps-item-mobile-');
      }
      return id;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAllVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();
})();
